import { render, staticRenderFns } from "./AAsignacionTablaS.vue?vue&type=template&id=2466792a&scoped=true"
import script from "./AAsignacionTablaS.vue?vue&type=script&lang=js"
export * from "./AAsignacionTablaS.vue?vue&type=script&lang=js"
import style0 from "./AAsignacionTablaS.vue?vue&type=style&index=0&id=2466792a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2466792a",
  null
  
)

export default component.exports